import React from 'react';
import { GiftIcon, CheckCircleIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'La Calculadora Anti-Inflación',
    value: 19,
    desc: 'Para calcular costos y precios sin enredos y proteger tu margen.'
  }, {
    num: 2,
    title: 'Guía “Ventas por WhatsApp Sin Vergüenza”',
    value: 17,
    desc: 'Textos listos para estados, grupos, seguimiento y cobranza.'
  }, {
    num: 3,
    title: 'Kit de Marca “Efecto Boutique”',
    value: 27,
    desc: 'Etiquetas y presentación para pasar de “postre casero” a producto premium.'
  }, {
    num: 4,
    title: '11 Salsas que transforman un flan común en uno caro',
    value: 21,
    desc: 'Para subir ticket y que te pidan “con esa salsa”.'
  }, {
    num: 5,
    title: 'Masterclass Técnica: “Cero fallas”',
    value: 29,
    desc: 'Soluciones rápidas si algo no te quedó como querías (para no tirar producción).'
  }, {
    num: 6,
    title: 'Guía de Medidas, envases y rendimiento',
    value: 15,
    desc: 'Cuántos vasitos salen por receta, equivalencias y cómo escalar sin arruinar nada.'
  }, {
    num: 7,
    title: 'Mini plan de venta semanal (qué ofrecer y cuándo)',
    value: 19,
    desc: 'Para ordenar tu semana y que no dependas de “a ver si sale”.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-gold-light border-y-4 border-gold" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <GiftIcon className="w-16 h-16 text-caramel-dark mx-auto mb-4" data-id="element-27" />
          <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-brown-dark" data-id="element-28">
            Reclama estos 7 bonos exclusivos si ordenas HOY
          </h2>
          <p className="text-xl text-gray-700 mt-4 font-medium" data-id="element-29">
            Si entras hoy, te doy 7 bonos prácticos (para que no solo cocines…
            sino que VENDAS).
          </p>
        </div>

        <div className="space-y-6" data-id="element-30">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-gold/30 flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-31">
              {/* Decorative corner */}
              <div className="absolute top-0 right-0 bg-caramel text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-32">
                BONO #{bonus.num}
              </div>

              <div className="bg-cream-dark w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-caramel" data-id="element-33">
                <GiftIcon className="w-8 h-8 text-caramel-dark" data-id="element-34" />
              </div>

              <div className="flex-1" data-id="element-35">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-brown-dark mb-2 pr-12" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 font-medium mb-3" data-id="element-37">{bonus.desc}</p>
                <div className="flex items-center gap-3 font-bold" data-id="element-38">
                  <span className="text-gray-400 line-through" data-id="element-39">
                    Valor US${bonus.value}
                  </span>
                  <span className="text-success-green bg-green-50 px-2 py-1 rounded text-sm uppercase tracking-wider" data-id="element-40">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value Box */}
        <div className="mt-12 bg-brown-dark text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl border-4 border-caramel relative overflow-hidden" data-id="element-41">
          <div className="absolute -right-10 -top-10 w-32 h-32 bg-caramel rounded-full opacity-20 blur-2xl" data-id="element-42"></div>
          <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-caramel rounded-full opacity-20 blur-2xl" data-id="element-43"></div>

          <p className="text-xl md:text-2xl font-medium text-cream mb-2" data-id="element-44">
            Valor total de los bonos:
          </p>
          <p className="text-5xl md:text-6xl font-heading font-extrabold text-caramel line-through decoration-urgency-red decoration-4 mb-4" data-id="element-45">
            +US$147
          </p>
          <div className="inline-block bg-success-green text-white font-heading font-bold text-2xl md:text-3xl px-8 py-4 rounded-xl shadow-lg transform scale-105" data-id="element-46">
            ¡TODOS GRATIS SI ORDENAS HOY!
          </div>
        </div>
      </div>
    </section>;
}